// extracted by mini-css-extract-plugin
export default {"details":"Details_details__giUUq","details__loader":"Details_details__loader__8N4rA"};